export default function ApplicationLogo(props) {
    return <img src="/rayanox-events.png" width="300" height="90" alt="Global Morocco Logo" className="w-auto h-auto max-h-[45px] md:max-h-[90px]" {...props} />;
}
